export default __webpack_public_path__ + "static/media/fast-forward.80ad5259.svg";